import { useModal } from '@/contexts/modal'
import CloseIcons from '@/icons/CloseIcons'
import { CustomerContract } from '@/modules/Contract/types'
import { IPermissionProps } from '@/types/shared'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'vnetwork-ui'

interface ITerminateProps extends IPermissionProps {
    contractID?: string
    contract: CustomerContract
}

const Terminate: React.FC<ITerminateProps> = ({ contractID, contract }) => {
    const { t } = useTranslation()
    const { setModal, open } = useModal()

    // Only show terminate button for active or expiring contracts
    const canTerminate = contract?.contract_status === 'active'

    if (!canTerminate) return null

    return (
        <>
            <Button
                size="small"
                variant="outlined"
                color="error"
                startIcon={<CloseIcons />}
                disabled={open}
                onClick={() =>
                    setModal('ContractModals/TerminateContractModal/index', {
                        contractID: contractID,
                        contract,
                    })
                }
            >
                {t('terminate_contract')}
            </Button>
        </>
    )
}

const TerminateComponent = (props: ITerminateProps) => {
    return <Terminate {...props} />
}

export default TerminateComponent
